"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CpcHelpers = exports.ApiHook = exports.ThreadHelpers = exports.PostHelpers = exports.NewsfeedHelpers = exports.MatterHelpers = exports.Formatter = exports.Color = exports.ApiHelpers = exports.ApiData = void 0;
exports.ApiData = __importStar(require("./api-data"));
exports.ApiHelpers = __importStar(require("./api-helpers"));
exports.Color = __importStar(require("./color"));
exports.Formatter = __importStar(require("./formatter"));
exports.MatterHelpers = __importStar(require("./matter-helpers"));
exports.NewsfeedHelpers = __importStar(require("./newsfeed-helpers"));
exports.PostHelpers = __importStar(require("./post-helpers"));
exports.ThreadHelpers = __importStar(require("./thread-helpers"));
exports.ApiHook = __importStar(require("./hooks/useApi"));
exports.CpcHelpers = __importStar(require("./cpc-helpers"));
